import React from 'react';
import { Grid } from '@material-ui/core';
import { UserPostModel } from '../../../NewsfeedModels';
import BulletSection from '../../components/BulletSection';
import ActionSection from '../../components/ActionSection';
import UserInfo from '../../components/UserInfoPopup';
import { track } from 'shared';
import { useHistory } from 'react-router';

interface IProps {
    user: UserPostModel;
    setSection: (page: number) => void;
}

export default function UserProfile({ user, setSection }: IProps) {
    const history = useHistory();

    function handleChatAction() {
        if (user.role === 'PROVIDER') {
            track('User Profile Popup: User clicked chat button with provider');
            history.push(`/messages/${user.id}`);
        } else {
            track('User Profile Popup: User clicked chat button with family');
            setSection(1);
        }
    }
    return (
        <Grid container>
            <Grid container item>
                <UserInfo user={user} />
            </Grid>
            <Grid container item style={{ paddingTop: 10 }}>
                <BulletSection user={user} />
            </Grid>
            <Grid container item>
                <ActionSection chatAction={handleChatAction} />
            </Grid>
        </Grid>
    );
}
